/** Keep the focused editor and actions above iOS/Android's on-screen keyboard. */
export function installViewport(){
 const viewport=window.visualViewport;if(!viewport)return;
 let frame=0;
 const update=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
  if(viewport.scale!==1)return;
  const root=document.documentElement.style;
  root.setProperty('--app-height',`${viewport.height}px`);root.setProperty('--app-offset',`${viewport.offsetTop}px`);
  root.setProperty('--keyboard-inset',`${Math.max(0,window.innerHeight-viewport.height-viewport.offsetTop)}px`);
 });};
 viewport.addEventListener('resize',update);viewport.addEventListener('scroll',update);update();
}
